














































import Vue from 'vue'
export default Vue.extend({
  name: 'EditorEpisodeList',
  props: {
    episodesThroughLens: {
      type: Array,
      default: null
    },
    friendlyVersionOfInitialTime: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dateNowMS: Date.now()
    }
  }
})
